import { cn } from "@/lib/utils";
import { MixedSection } from "components/domain/contents/sections/MixedSection";
import { Mix_Content_Tag_Enum_Enum } from "graphql/generated";
import { LIMIT, buildQueryVariables } from "utils/buildQueryVariables";

interface DesktopLayoutProps {
    tags: Mix_Content_Tag_Enum_Enum[] | null;
    isTagPage?: boolean;
}

/**
 * Desktop 레이아웃 (≥ 1025px)
 *
 * 표시 규칙:
 * - MixedSection만 표시 (OriginalSection, RecentSection 대체)
 * - tags 필터링은 동일하게 적용
 * - 태그 필터링 시: 모든 콘텐츠 (original + recent) 표시
 */
export const DesktopLayout = ({
    tags,
    isTagPage = false
}: DesktopLayoutProps) => {
    return (
        // 태그 페이지는 PageTitle의 mb-6이 간격을 담당하므로 상단 여백 제거
        <div
            className={cn(
                "hidden lg:block",
                !isTagPage && "mt-10 tablet:mt-20"
            )}
        >
            <MixedSection
                data-observer-id="mixed"
                contentSection="mixed"
                variables={buildQueryVariables(
                    tags ? null : "recent",
                    tags,
                    LIMIT.default
                )}
            />
        </div>
    );
};
